import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "estate-card__photos" }
const _hoisted_2 = { class: "estate-card__info" }
const _hoisted_3 = { class: "estate-card__actions" }
const _hoisted_4 = { class: "estate-card__address" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListGallery = _resolveComponent("AdListGallery")!
  const _component_AdLabels = _resolveComponent("AdLabels")!
  const _component_AdListItemCompare = _resolveComponent("AdListItemCompare")!
  const _component_AdListItemLike = _resolveComponent("AdListItemLike")!
  const _component_AdListItemFavorite = _resolveComponent("AdListItemFavorite")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_AdListItemParams = _resolveComponent("AdListItemParams")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classId, "estate-card estate-card--basic"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AdListGallery, {
        images: _ctx.ad.images,
        adGuid: _ctx.ad.adGuid,
        estateType: _ctx.ad.estateType,
        estateSubType: _ctx.ad.estateSubType,
        imageLimitCount: _ctx.imageLimitCount,
        width: 610,
        height: 440
      }, null, 8, ["images", "adGuid", "estateType", "estateSubType", "imageLimitCount"]),
      _createVNode(_component_AdLabels, { ad: _ctx.ad }, null, 8, ["ad"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AdListItemCompare, { ad: _ctx.ad }, null, 8, ["ad"]),
        _createVNode(_component_AdListItemLike, { ad: _ctx.ad }, null, 8, ["ad"]),
        _createVNode(_component_AdListItemFavorite, { ad: _ctx.ad }, null, 8, ["ad"])
      ]),
      _createVNode(_component_AdListItemPrice, { ad: _ctx.ad }, null, 8, ["ad"]),
      _createVNode(_component_AdListItemParams, { ad: _ctx.ad }, null, 8, ["ad"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.address), 1)
    ])
  ], 2))
}